import DOMPurify from 'dompurify';

/**
 * Sanitize a string by stripping all HTML tags and dangerous content.
 * Uses DOMPurify with no allowed tags — returns plain text only.
 *
 * Used to sanitize all user-supplied and Monday.com-sourced data
 * before rendering, as required by monday.com app security review.
 */
export function sanitize(input: string): string {
  return DOMPurify.sanitize(input, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
}

/**
 * Sanitize a string or null value. Returns null if input is null.
 */
export function sanitizeNullable(input: string | null): string | null {
  return input === null ? null : sanitize(input);
}